/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/TrendingMenu/theme';

export const TrendingMenuTheme = theme;
